import {Controller} from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["field", 'fieldName']

  connect() {

  }

  handleSubmit() {
    Rails.fire(this.fieldTarget.form, "submit");
  }

  switchTab(e) {
    e.preventDefault();
    let id = $(e.target).parent('.dropdown-tabs')[0].id.split('-')[1];
    $('.dropdown-tabs').removeClass('is-active');
    $('.dropdown-groups').addClass('is-hidden');
    $('#tab-' + id).addClass('is-active');
    $('#group-' + id).removeClass('is-hidden');
  }

  selectItem(e) {
    $('#form-dropdown-values .selected').removeClass('selected')
    this.fieldTarget.value = $(e.target).parent('.form-dropdown-item').attr('value');
    this.fieldNameTarget.innerText = $(e.target).text();
    $(e.target).parent('.form-dropdown-item').addClass('selected');
  }

  selectItemAndSubmit(e) {
    this.selectItem(e);
    this.handleSubmit();
  }


}
